export const BADGE_SIZE = 32;
